export { default } from "./QuickAccess.container";
